import { addDays, addMinutes, differenceInMilliseconds, endOfDay, startOfDay } from 'date-fns'

export const SLOT_MINUTES = 30
/** 가장 빠른 예약 슬롯까지의 여유. 30분 단위 내림 뒤 60분이라 실제로는 30~60분 뒤가 된다 */
export const LEAD_MINUTES = 60
/** 예약 시각 이 시간 전에 등록·변경이 마감된다 (BE와 동일) */
export const SUBMIT_DEADLINE_MINUTES = 5
/** 오늘 포함 선택 가능 일수 */
export const HORIZON_DAYS = 7

const MINUTE_MS = 60 * 1000

export const floorToSlot = (date: Date): Date => {
  const slot = new Date(date)
  slot.setMinutes(Math.floor(slot.getMinutes() / SLOT_MINUTES) * SLOT_MINUTES, 0, 0)
  return slot
}

export const earliestSlot = (now: Date): Date => addMinutes(floorToSlot(now), LEAD_MINUTES)

export const lastSelectableSlot = (now: Date): Date =>
  floorToSlot(endOfDay(addDays(startOfDay(now), HORIZON_DAYS - 1)))

const isOnSlotBoundary = (date: Date) =>
  date.getMinutes() % SLOT_MINUTES === 0 && date.getSeconds() === 0 && date.getMilliseconds() === 0

export const isSelectableSlot = (slot: Date, now: Date): boolean =>
  isOnSlotBoundary(slot) &&
  slot.getTime() >= earliestSlot(now).getTime() &&
  slot.getTime() <= lastSelectableSlot(now).getTime()

export const isBeforeSubmitDeadline = (slot: Date, now: Date): boolean =>
  differenceInMilliseconds(slot, now) > SUBMIT_DEADLINE_MINUTES * MINUTE_MS

export const daySlots = (day: Date): Date[] => {
  const start = startOfDay(day)
  return Array.from({ length: (24 * 60) / SLOT_MINUTES }, (_, i) =>
    addMinutes(start, i * SLOT_MINUTES),
  )
}

export const firstSelectableSlotOfDay = (day: Date, now: Date): Date | null =>
  daySlots(day).find((slot) => isSelectableSlot(slot, now)) ?? null
